module.exports = __webpack_public_path__ + "static/media/haikyuu.e4a1eaa3.png";